<template>
  <span :class="'AppTooltip_' + position" :data-title="text">
    <slot />
  </span>
</template>

<script>
//TODO: Finish tooltip

export default {
  name: "AppTooltip",
  props: {
    text: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top",
      validator: (value) => {
        return [
          "top",
          "bottom",
          "left",
          "right"
        ].includes(value);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[data-title]:hover:before {
  opacity: 1;
  transition: all 0s ease 0.1s;
  visibility: visible;
}
[data-title]:before {
  content: attr(data-title);
  position: absolute;
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
  white-space: pre-line;
  width: 25.0rem;

  box-shadow: 0 0.5rem 0.5rem 0.5rem rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 0.25rem;
  padding: 1.0rem;
}
[data-title]:hover:after {
  opacity: 1;
  transition: all 0s ease 0.1s;
  visibility: visible;
}
[data-title]:after {
  position: absolute;
  white-space: nowrap;
  opacity: 0;
  z-index: 99999;
  visibility: hidden;

  content: '';
}
[data-title] {
  position: relative;
}
.AppTooltip_bottom:before {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
}
.AppTooltip_bottom:after {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: solid 0.5rem white;
  border-left: solid 0.5rem transparent;
  border-right: solid 0.5rem transparent;
}
.AppTooltip_top:before {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
}
.AppTooltip_top:after {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  border-top: solid 0.5rem white;
  border-left: solid 0.5rem transparent;
  border-right: solid 0.5rem transparent;
}
.AppTooltip_left:before {
  right: calc(100% + 0.5rem);
  margin: auto 0;
  display: inline-block;
}
.AppTooltip_left:after {
  left: -0.5rem;
  margin: 0.5rem 0;
  border-left: solid 0.5rem white;
  border-top: solid 0.5rem transparent;
  border-bottom: solid 0.5rem transparent;
}
.AppTooltip_right:before {
  left: calc(100% + 0.5rem);
  transform: translateY(-40%);
  margin: auto 0;
  display: inline-block;
}
.AppTooltip_right:after {
  right: -0.5rem;
  transform: translateY(-100%);
  border-right: solid 0.5rem white;
  border-top: solid 0.5rem transparent;
  border-bottom: solid 0.5rem transparent;
}
</style>
